import { render, staticRenderFns } from "./spinner-loader.vue?vue&type=template&id=6e51954e"
import script from "./spinner-loader.vue?vue&type=script&lang=ts"
export * from "./spinner-loader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports